










import { Vue, Component } from 'vue-property-decorator';
import MantanedorTramos from '@/pantallas/Conecta/MantenedorTramos/index.vue';

@Component({
  components: { MantanedorTramos },
})
export default class MantanedorTramosPantalla extends Vue {}
